import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  getMedia,
  useMedia,
  fetch,
};

let g_versionMap: any = {};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done?.();
}
function getMedia(volume_id: number, media_id: number) {
  const key = `${volume_id}-${media_id}`;
  return g_versionMap[key];
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
export function useMedia(volume_id: number, media_id: number) {
  const _get = React.useCallback(
    () => getMedia(volume_id, media_id),
    [volume_id, media_id]
  );
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetch(params: any, done?: any) {
  const { volume_id, media_id } = params;
  const opts = {
    url: `/api/1/media/${media_id}`,
    query: { volume_id },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('VersionStore.fetch: err:', err, body);
    } else {
      const key = `${volume_id}-${media_id}`;
      const old = g_versionMap[key];
      if (!util.deepEqual(old, body)) {
        g_versionMap[key] = body;
        _emit('update_version');
      }
    }
    done?.(err, body);
  });
}
